import React from 'react';
import {
  Button,
  Dialog,
  Box,
  makeStyles,
  DialogTitle,
  DialogContent,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
} from '@material-ui/core';
import { CustomToast } from '@jumbo/components/custom/Toast';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
  labelCell: {
    fontWeight: 'bold',
    width: '45%',
    verticalAlign: 'top',
  },
  stripedRow: {
    backgroundColor: '#f4f4f7',
  },
}));

const ProfileModal = props => {
  const { openDialog = false, close } = props;
  const classes = addStyle();
  const user = JSON.parse(sessionStorage.getItem('user'));

  const onCloseDialog = event => {
    event.preventDefault();
    close();
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}>
        Información de Usuario
      </DialogTitle>

      <DialogContent dividers>
        {user ? (
          <TableContainer component={Paper} elevation={0} style={{ width: '100%' }}>
            <Table size="medium">
              <TableBody>
                <TableRow className={classes.stripedRow}>
                  <TableCell className={classes.labelCell}>Nombre</TableCell>
                  <TableCell>
                    {`${user.names} ${user.last_name} ${user.mother_last_name}`}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.labelCell}>RUT</TableCell>
                  <TableCell>{`${user.run}-${user.dv}`}</TableCell>
                </TableRow>

                <TableRow className={classes.stripedRow}>
                  <TableCell className={classes.labelCell}>Email</TableCell>
                  <TableCell>{user.email}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.labelCell}>Entidad</TableCell>
                  <TableCell>{user.organization?.name || '-'}</TableCell>
                </TableRow>

                <TableRow className={classes.stripedRow}>
                  <TableCell className={classes.labelCell}>Roles</TableCell>
                  <TableCell>
                    {user.roles_user?.length ? (
                      <Box component="ul" m={0} p={0} style={{ listStyle: 'none' }}>
                        {user.roles_user.map((item, index) => (
                          <li key={index}>
                            <Typography variant="body2">{item.name}</Typography>
                          </li>
                        ))}
                      </Box>
                    ) : (
                      <Typography variant="body2" color="textSecondary">
                        Sin roles
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No hay información de usuario en sesión.
          </Typography>
        )}

        <Box display="flex" justifyContent="flex-end" mb={4} mt={2}>
          <Button onClick={onCloseDialog} color="primary" variant="outlined">
            Cerrar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileModal;
